import PlanList from "common/Plan/Plan";
import React from "react";

const Plan = () => {
  return (
    <div className="page-content">
      <PlanList />
    </div>
  );
};

export default Plan;